// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2ky7t","notes":"Notes_notes__39mBU"};